<app-segov-sigepo-portal-body>
  <div class="container">
    <h1 class="error-code">404</h1>
    <h2 class="error-message">Página não encontrada.</h2>
    <p class="error-description">Conteúdo indisponível no momento. Tente novamente em instantes.</p>
  </div>
</app-segov-sigepo-portal-body>
